<router-outlet></router-outlet>
@if (!isProd) {
  <div class="dev">DEVELOPMENT v{{ version }}</div>
}
